import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@orderna/admin-panel/src/environments/environment';
import { firstValueFrom } from 'rxjs';
import { SuccessResponse } from '../../shared/success-response';
import { CloseCashRegisterSessionRequestDto } from './dtos/close-cash-register-session.request.dto';
import { FindMyOpenCashRegisterSessionResponseDto } from './dtos/find-my-open-cash-register-session.response.dto';
import { OpenCashRegisterSessionRequestDto } from './dtos/open-cash-register-session.request.dto';
import { CloseCashRegisterSessionResponseDto } from './dtos/close-cash-register-session.response.dto';
import { OpenCashRegisterSessionResponseDto } from './dtos/open-cash-register-session.response.dto';
import { FindLatestCashRegisterSessionResponseDto } from './dtos/find-latest-cash-register-session.response.dto';

@Injectable({
  providedIn: 'root',
})
export class CashRegisterSessionsApiService {
  private http = inject(HttpClient);

  private url(registerId?: number): string {
    return registerId
      ? `${environment.api}/cash-drawers/${registerId}/sessions`
      : `${environment.api}/cash-drawers/sessions`;
  }

  async findLatestCashRegisterSession(
    registerId: number,
  ): Promise<FindLatestCashRegisterSessionResponseDto> {
    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindLatestCashRegisterSessionResponseDto>>(
        `${this.url(registerId)}/latest`,
      ),
    );

    return response.data;
  }

  async findMyOpenCashRegisterSession() {
    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindMyOpenCashRegisterSessionResponseDto>>(
        `${this.url()}/me/open`,
      ),
    );

    return response.data;
  }

  async openCashRegisterSession(
    registerId: number,
    dto: OpenCashRegisterSessionRequestDto,
  ): Promise<OpenCashRegisterSessionResponseDto> {
    const response = await firstValueFrom(
      this.http.post<SuccessResponse<OpenCashRegisterSessionResponseDto>>(
        `${this.url(registerId)}/open-session`,
        dto,
      ),
    );

    return response.data;
  }

  async closeCashRegisterSession(
    registerId: number,
    dto: CloseCashRegisterSessionRequestDto,
  ): Promise<CloseCashRegisterSessionResponseDto> {
    const response = await firstValueFrom(
      this.http.patch<SuccessResponse<CloseCashRegisterSessionResponseDto>>(
        `${this.url(registerId)}/latest/close-session`,
        dto,
      ),
    );

    return response.data;
  }
}
